<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'baseProductionData' }">基地生产数据</el-breadcrumb-item>
        <el-breadcrumb-item>新增基地生产数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result :show-pager-on-one-page="false" :loading="tableLoading">
      <div class="wrap-table-info-display">
        <el-button size="small" type="primary" @click="addRow"> 继续添加 </el-button>

        <el-button size="small" @click="resetTableData"> 重置 </el-button>

        <div style="position: absolute; right: 0">
          <el-button size="small" type="success" @click="submitData"> 提交 </el-button>
        </div>
      </div>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <!--<el-table-column-->
        <!--prop="farmId"-->
        <!--width="80"-->
        <!--align="center"-->
        <!--label="id">-->
        <!--</el-table-column>-->

        <el-table-column prop="farmTitle" width="100" align="center" label="基地名称"> </el-table-column>

        <el-table-column prop="" width="150" align="center" label="种植位置">
          <template slot-scope="scope">
            <el-select @change="areaIdChanged" @focus="getIndex(scope.row.$index)" style="width: 100%" size="small" v-model="scope.row.areaId">
              <el-option v-for="item in farmAreaList" :key="item.areaId" :value="item.areaId" :label="item.areaTitle"> </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="measureTotal" width="120" align="center" label="亩数/总亩数"> </el-table-column>

        <el-table-column prop="" width="150" align="center" label="品种">
          <template slot-scope="scope">
            <el-select style="width: 100%" size="small" v-model="scope.row.categoryId">
              <el-option v-for="item in farmCategoryList" :key="item.categoryId" :value="item.categoryId" :label="item.categoryTitle"> </el-option>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column prop="" width="100" align="center" label="品名">
          <template slot-scope="scope">
            <el-input size="small" v-model.trim="scope.row.goodTitle"></el-input>
          </template>
        </el-table-column>

        <el-table-column prop="" width="150" align="center" label="定植时间">
          <template slot-scope="scope">
            <el-date-picker style="width: 100%" size="small" v-model="scope.row.plantTime" type="date" placeholder="选择日期"> </el-date-picker>
          </template>
        </el-table-column>

        <el-table-column prop="" width="150" align="center" label="供应开始时间">
          <template slot-scope="scope">
            <el-date-picker @change="checkStartDateFormat" @focus="getIndex(scope.row.$index)" style="width: 100%" size="small" v-model="scope.row.supplypStarTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column>

        <el-table-column prop="" width="150" align="center" label="供应结束时间">
          <template slot-scope="scope">
            <el-date-picker @change="checkEndDateFormat" @focus="getIndex(scope.row.$index)" style="width: 100%" size="small" v-model="scope.row.supplypEndTime" type="date" placeholder="选择日期">
            </el-date-picker>
          </template>
        </el-table-column>

        <el-table-column prop="supplyTimes" align="center" width="100" label="供应次数">
          <template slot-scope="scope">
            <el-input @blur="supplyBlur('supplyTimes', scope.row.supplyTimes)" @focus="getIndex(scope.row.$index)" size="small" v-model.trim="scope.row.supplyTimes"> </el-input>
          </template>
        </el-table-column>

        <el-table-column prop="" width="150" align="center" label="每次供应产量(斤)">
          <template slot-scope="scope">
            <el-input @blur="supplyBlur('supplyTimesProduce', scope.row.supplyTimesProduce)" @focus="getIndex(scope.row.$index)" size="small" v-model.trim="scope.row.supplyTimesProduce"> </el-input>
          </template>
        </el-table-column>

        <el-table-column prop="totalProduce" align="center" label="总产量"> </el-table-column>

        <el-table-column prop="measureProduce" align="center" label="亩产"> </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      farmId: "",
      farmAreaList: [],
      farmCategoryList: [],
      tableLoading: false,
      tableData: [],
      areaIdList: [],
      measureTotalList: [],
      $index: 0,
      farmTitle: "",
      count: 0,
    };
  },
  mounted() {
    const farmId = this.$route.params.baseId;
    this.farmId = farmId;
    if (farmId) {
      this.loadFarmAreaList(farmId);
      this.loadCategoryList();
      this.loadTableData(farmId);
    } else {
      this.$message.error("获取路由参数失败，请刷新页面或重新登录。");
    }
  },
  methods: {
    /**
     * 初始化种植位置下拉框列表
     * @param farmId
     */
    loadFarmAreaList(farmId) {
      this.$http({
        url: global.apiUrl + "/farm/farm-area?farmId=" + farmId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.farmAreaList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化品种下拉框列表
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/farm/farm-category",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.farmCategoryList = res.body.data.dataList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化table数据
     * @param farmId
     */
    loadTableData(farmId) {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-product-write",
        method: "GET",
        params: {
          farmId: farmId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.farmTitle = this.tableData[0].farmTitle;
              this.measureTotalList = res.body.data.areaList;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 继续添加row
     */
    addRow() {
      const rowData = {
        $index: this.tableData.length,
        farmId: this.farmId,
        farmTitle: this.farmTitle,
        areaTitle: "",
        measureTotal: "",
        categoryTitle: "",
        plantTime: "",
        supplypStarTime: "",
        supplypEndTime: "",
        supplyTimes: "",
        supplyTimesProduce: "",
        totalProduce: 0,
        measureProduce: 0,
        areaId: "",
        categoryId: "",
        goodTitle: "",
      };
      this.tableData.push(rowData);
    },
    /**
     * 重置table数据
     */
    resetTableData() {
      this.areaIdList = [];
      this.tableData.map(item => {
        item.areaId = "";
        item.areaTitle = "";
        item.measureTotal = "";
        item.categoryId = "";
        item.categoryTitle = "";
        item.plantTime = "";
        item.supplypStarTime = "";
        item.supplypEndTime = "";
        item.supplyTimes = "";
        item.supplyTimesProduce = "";
        item.goodTitle = "";
        item.totalProduce = 0;
        item.measureProduce = 0;
      });
    },
    /**
     * 提交数据
     */
    submitData() {
      this.$http({
        url: global.apiUrl + "/farm/farm-production-insert",
        method: "POST",
        body: {
          farmProdutionDataList: this.tableData,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 种植位置事件改变方法
     * @param val
     */
    areaIdChanged(val) {
      let flag = false;
      this.count = this.checkRepeatCount(val);
      if (this.areaIdList.length > 0) {
        for (let i = 0; i < this.areaIdList.length; i++) {
          if (this.$index === this.areaIdList[i].$index) {
            this.areaIdList[i].areaId = val;
            flag = false;
          } else {
            flag = true;
          }
        }
        const isRepeat = this.checkIsRepeat(this.$index);
        if (this.count > 2) {
          this.$message.error("同一种植位置不能重复三次以上");
          this.count = 0;
          this.tableData[this.$index].areaId = "";
          this.tableData[this.$index].measureTotal = "";
          this.tableData[this.$index].totalProduce = 0;
          this.tableData[this.$index].measureProduce = 0;
          this.tableData[this.$index].supplyTimes = "";
          this.tableData[this.$index].supplyTimesProduce = "";
          this.areaIdList.map((item, index) => {
            if (item.areaId === this.tableData[this.$index].areaId) {
              this.areaIdList.splice(index, 1);
            }
          });
          return;
        } else {
          if (flag && !isRepeat) {
            this.areaIdList.push({
              areaId: val,
              $index: this.$index,
            });
          }
        }
      } else {
        this.areaIdList.push({
          areaId: val,
          $index: this.$index,
        });
      }
      // 种植位置选择次数
      let areaCount = 0;
      // 亩数
      let areaUnit = 0;
      this.tableData.map((item, index) => {
        this.measureTotalList.map((item1, index1) => {
          if (item.areaId === item1.areaId) {
            // 总亩数
            const measureTotal = this.measureTotalList[index1].measureTotal;
            areaCount = this.checkRepeatCount(this.tableData[index].areaId);
            // 计算当前种植位置对应的亩数
            // 如果计算得到的值不为整数则需要保留两位小数
            if (this.checkIsInteger(measureTotal / areaCount)) {
              areaUnit = measureTotal / areaCount;
            } else {
              areaUnit = (measureTotal / areaCount).toFixed(2);
            }
            this.tableData[index].areaUnit = areaUnit;
            if (this.tableData[index].totalProduce) {
              this.tableData[index].measureProduce = (this.tableData[index].totalProduce / areaUnit).toFixed(2);
            }
            this.tableData[index].measureTotal = areaUnit + "/" + measureTotal + "";
          }
        });
      });
    },
    /**
     * 获取下标
     * @param $index
     */
    getIndex($index) {
      this.$index = $index;
    },
    checkIsRepeat(index) {
      let i = this.areaIdList.length;
      while (i--) {
        if (this.areaIdList[i].$index === index) {
          return true;
        }
      }
      return false;
    },
    /**
     * 计算同一种植位置重复次数
     * @param areaId
     * @return {number}
     */
    checkRepeatCount(areaId) {
      let count = 0;
      for (let i = 0; i < this.areaIdList.length; i++) {
        if (areaId === this.areaIdList[i].areaId) {
          count += 1;
        }
      }
      return count;
    },
    /**
     * 判断是否为整数
     * @param val
     * @return {boolean}
     */
    checkIsInteger(val) {
      if (val) {
        if (val % 1 === 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    /**
     * 检测供应开始时间格式
     * @param val
     */
    checkStartDateFormat(val) {
      const $index = this.$index;
      const startDate = this.formatDate(val);
      const endDate = this.formatDate(this.tableData[$index].supplypEndTime);
      this.checkDateFormat(startDate, endDate, $index, 0);
    },
    /**
     * 检测供应结束时间格式
     * @param val
     */
    checkEndDateFormat(val) {
      const $index = this.$index;
      const startDate = this.formatDate(this.tableData[$index].supplypStarTime);
      const endDate = this.formatDate(val);
      this.checkDateFormat(startDate, endDate, $index, 1);
    },
    /**
     * 检测供应时间格式
     * @param startDate
     * @param endDate
     * @param $index
     * @param status
     */
    checkDateFormat(startDate, endDate, $index, status) {
      if (startDate && endDate && startDate > endDate) {
        this.$message.error("供应开始时间不能大于供应结束时间");
        if (status === 0) {
          this.tableData[$index].supplypStarTime = "";
        }
        if (status === 1) {
          this.tableData[$index].supplypEndTime = "";
        }
      }
    },
    /**
     * 格式化时间
     * @param date
     * @return {*}
     */
    formatDate(date) {
      if (date) {
        return new Date(date).getTime();
      } else {
        return "";
      }
    },
    /**
     * 供应次数/每次供应量(斤)失去焦点事件
     * @param key
     * @param val
     */
    supplyBlur(key, val) {
      const $index = this.$index;
      if (!isNaN(val)) {
        const flag = this.checkIsInteger(val);
        if (!flag) {
          this.$message.error("请输入正整数");
          this.tableData[$index][key] = "";
        } else {
          this.tableData[$index][key] = this.setPositiveInteger(val);
          if (this.tableData[$index].supplyTimes !== undefined && this.tableData[$index].supplyTimesProduce !== undefined) {
            this.tableData[$index].totalProduce = this.tableData[$index].supplyTimes * this.tableData[$index].supplyTimesProduce;
          } else {
            this.tableData[$index].totalProduce = 0;
          }
          if (this.tableData[$index].areaUnit !== "") {
            this.tableData[$index].measureProduce = (this.tableData[$index].totalProduce / this.tableData[$index].areaUnit).toFixed(2);
          } else {
            this.tableData[$index].measureProduce = 0;
          }
        }
      } else {
        this.$message.error("请输入正整数");
        this.tableData[$index][key] = "";
      }
    },
    /**
     * 检测是否为正整数
     * @param val
     * @return {Number|number}
     */
    setPositiveInteger(val) {
      if (val === "") {
        val = 0;
      }
      val = val + "";
      if (val.substring(0, 1) === "-") {
        return parseInt(val.substring(1, val.length));
      } else {
        return parseInt(val);
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
